import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerMock } from '../mocks/app-serve.mock';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IKeynuaWidgetResponse } from '@app/core/models/biometrics.model';
import { URLS } from './url.constants';
import { GET_KEYNUA_WIDGET_TOKEN } from '../mocks/app-control.mock';
import { HandleTokenService } from '@app/core/services/handle-token.service';
import { map } from 'rxjs/operators';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class BiometricsAPI {
  public _httpClient = new HttpClient(this._httpBackend);
  private _localServer: ServerMock = new ServerMock();

  constructor(
    private _http: HttpClient,
    public _httpBackend: HttpBackend,
    private _handleTokenService: HandleTokenService
  ) {}

  public getKeynuaWidgetResponse(transactionId: string): Observable<IKeynuaWidgetResponse> {
    const { production, isTestServer } = environment;
    const httpRequest: any = GET_KEYNUA_WIDGET_TOKEN;
    const token = this._handleTokenService.getAccessToken();
    const options = {
      headers: this._setHeaders(token),
    };
    return production && !isTestServer
      ? this._httpClient.get<IKeynuaWidgetResponse>(
          `${API_URL}${URLS.GET_KEYNUA_WIDGET_TOKEN}?transaction_id=${transactionId}`,
          options
        )
      : this._localServer.request(httpRequest).pipe(
          map((response: HttpResponse<any>) => {
            const keynuaWidgetResponse: IKeynuaWidgetResponse = response?.body;
            return keynuaWidgetResponse;
          })
        );
  }

  private _setHeaders(transactionToken):
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } {
    return {
      'Content-Type': 'application/json',
      Authorization: `Token: ${transactionToken}`,
    };
  }
}
